
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PayRateInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PayRate"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryLong"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryShort"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"detention"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pickup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pumpHose"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"route"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":112}};
    doc.loc.source = {"body":"fragment PayRateInfo on PayRate {\n  id\n  deliveryLong\n  deliveryShort\n  detention\n  pickup\n  pumpHose\n  route\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
